import React, { useState, useEffect } from "react";
import {
  Card,
  Flex,
  Button,
  ConfigProvider,
  Col,
  Row,
  Table,
  Progress,
  Input,
} from "antd";

import { ReloadOutlined } from "@ant-design/icons";

import axios from "axios";
import confromationimg from "../../photos/confirm.png";
import Visitedimg from "../../photos/visited.png";
import Reschedule from "../../photos/reschedule.png";
import Cancel from "../../photos/cancel.png";
// import { Bar } from "@ant-design/charts";
import DefaultLayout from "../../Defaultlayout/DefaultLayout";
import {
  API_BASE_URL,
  APPOINTMENT_LIST,
  directToken,
  LIST_OF_MASTER_SPECIALITY,
} from "../services/end_points";
// ✅ Register required components
import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register the necessary components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// const Dashbord = () => {
//   const [isDateInput, setIsDateInput] = useState(false);
//   const [toDateInput, setToDateInput] = useState(false);
//   const [dashboard, setDashboard] = useState({
//     totaldoctor: 0,
//     totalCount: [],
//     totalAppt: 0,
//     totalHospital: 0,
//     totalLocation: 0,
//   });
//   const [speciality, setSpeciality] = useState([]);
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [filteredApptCount, setFilteredApptCount] = useState(0);
//   const [totalApptCount, setTotalApptCount] = useState(0);
//   const [visited, setVisited] = useState(0);
//   const [reschedule, setReschedule] = useState(0);
//   const [confirm, setConfirm] = useState(0);
//   const [cancel, setCancel] = useState(0);
//   const [appt, setAppt] = useState([]);
//   const [values, setValues] = useState([]);
//   const userId = localStorage.getItem("userid");
//   const [chartData, setChartData] = useState({
//     yField: "value",
//     xField: "type",
//     colorField: "type",
//     data: [],
//     animation: {
//       appear: {
//         animation: "scale-in-x", // Change this if needed
//         duration: 1000,
//       },
//     },
//   });
//   const handleFocus = () => setIsDateInput(true);
//   const handleBlur = (e) => {
//     if (!e.target.value) setIsDateInput(false);
//   };

//   const handleFocusTo = () => setToDateInput(true);
//   const handleBlurTo = (e) => {
//     if (!e.target.value) setToDateInput(false);
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const url = `${API_BASE_URL}${APPOINTMENT_LIST}${userId}`;
//         const params = fromDate && toDate ? { fromDate, toDate } : {};
//         const headers = {
//           "authentication-token": `${directToken}`,
//         };

//         const [appointmentResponse, specialityResponse] = await Promise.all([
//           axios.get(url, { headers, params }),
//           axios.get(`${API_BASE_URL}${LIST_OF_MASTER_SPECIALITY}`),
//         ]);

//         const appointments = appointmentResponse.data.list || [];
//         const specialities = specialityResponse.data.list || [];
//         setValues(appointments);

//         const specialityMap = specialities.reduce((map, speciality) => {
//           map[speciality.id] = speciality.specialities_names;
//           return map;
//         }, {});

//         const filteredAppointmentsByDate =
//           fromDate && toDate
//             ? appointments.filter((appt) => {
//                 const appointmentDate = new Date(appt.createdAt);
//                 return (
//                   appointmentDate >= new Date(fromDate) &&
//                   appointmentDate <= new Date(toDate)
//                 );
//               })
//             : appointments;

//         const groupedAppointments = filteredAppointmentsByDate.reduce(
//           (acc, appt) => {
//             const key = `${appt.doctorId}-${appt.doctorSpecialityId}`;
//             if (!acc[key]) {
//               acc[key] = {
//                 ...appt,
//                 specialities: [specialityMap[appt.doctorSpecialityId]],
//               };
//             } else {
//               acc[key].specialities.push(
//                 specialityMap[appt.doctorSpecialityId]
//               );
//             }
//             return acc;
//           },
//           {}
//         );

//         const filteredAppointments = Object.values(groupedAppointments);
//         setSpeciality(specialities);
//         setAppt(filteredAppointments);

//         let visitedCount = 0;
//         let rescheduleCount = 0;
//         let confirmCount = 0;
//         let cancelCount = 0;
//         filteredAppointmentsByDate.forEach((appt) => {
//           switch (appt.status) {
//             case "Visited":
//               visitedCount++;
//               break;
//             case "Rescheduled":
//               rescheduleCount++;
//               break;
//             case "Confirmed":
//               confirmCount++;
//               break;
//             case "Cancelled":
//               cancelCount++;
//               break;
//             default:
//               break;
//           }
//         });

//         setVisited(visitedCount);
//         setReschedule(rescheduleCount);
//         setConfirm(confirmCount);
//         setCancel(cancelCount);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     fetchData();
//   }, [userId, fromDate, toDate]);

//   const handleReload = () => {
//     setTotalApptCount(0);
//     setFromDate("");
//     setToDate("");
//   };

//   const columns = [
//     {
//       title: "Doctor",
//       dataIndex: "doctorName",
//       key: "doctorName",
//       width: "3rem",
//       maxWidth: "3rem",
//       minWidth: "2.5rem",
//     },
//     {
//       title: "Specialty",
//       dataIndex: "specialitiesName",
//       key: "specialitiesName",
//       width: "5rem",
//       maxWidth: "5rem",
//       minWidth: "4.5rem",
//     },
//     {
//       title: "Appointment",
//       dataIndex: "Appointment",
//       key: "Appointment",
//       width: "7.5rem",
//       maxWidth: "7rem",
//       minWidth: "6.5rem",
//     },
//     {
//       title: "Visited",
//       dataIndex: "Visited",
//       key: "Visited",

//       width: "5rem",
//       maxWidth: "5rem",
//       minWidth: "4.5rem",
//     },
//     {
//       title: "Visit Conversion",
//       dataIndex: "Total",
//       key: "Total",
//       render: (total, record) => {
//         const totalAppointments = parseFloat(record.Appointment) || 0;
//         const visitedAppointments = parseFloat(record.Visited) || 0;

//         const percentage =
//           totalAppointments > 0
//             ? (visitedAppointments / totalAppointments) * 100
//             : 0;

//         return (
//           <Progress
//             percent={percentage.toFixed(0)}
//             status={percentage === 100 ? "success" : "normal"}
//           />
//         );
//       },
//     },
//   ];

//   const tableData = appt.map((item, index) => ({
//     key: index.toString(),
//     doctorName: item.doctorName,
//     specialitiesName: item.specialitiesName,
//     Appointment: item.Appointment,
//     Visited: item.Visited,
//     Total: `${parseFloat(item.Total || 0).toFixed(0)}%`,
//   }));
//   const specialtyPriceMap = values.reduce((map, item) => {
//     if (item.specialitiesName) {
//       map[item.specialitiesName] =
//         (map[item.specialitiesName] || 0) + parseFloat(item.charges || 0);
//     }
//     return map;
//   }, {});

//   const data = Object.keys(specialtyPriceMap)
//     .map((specialty) => ({
//       type: specialty,
//       value: specialtyPriceMap[specialty],
//     }))
//     .sort((a, b) => b.value - a.value);

//   // const config = {
//   //   yField: "value",
//   //   xField: "type",
//   //   colorField: "type",
//   //   data, // Make sure this data is properly structured
//   //   animation: {
//   //     appear: {
//   //       animation: "scale-in-x", // You can change this to any other animation like 'fade-in', 'zoom-in', etc.
//   //       duration: 1000, // Animation duration in milliseconds
//   //     },
//   //   },
//   // };
//   const config = {
//     yField: "value",
//     xField: "type",
//     colorField: "type",
//     data, // Make sure this data is properly structured
//     animation: {
//       appear: {
//         animation: "scale-in-x", // You can change this to any other animation like 'fade-in', 'zoom-in', etc.
//         duration: 1000, // Animation duration in milliseconds
//       },
//     },
//   };

//   // Map the data correctly using 'type' and 'value' as keys
//   const chartnewData = config.data.map((item) => ({
//     type: item.type, // Ensure 'type' exists in 'item'
//     value: item.value, // Ensure 'value' exists in 'item'
//   }));

//   // Log the data for debugging
//   console.log("Chart Data to be updated:", chartnewData);

//   // Only update state if the data is different
//   useEffect(() => {
//     // Check if chartData needs to be updated
//     if (JSON.stringify(chartData.data) !== JSON.stringify(chartnewData)) {
//       setChartData({
//         yField: "value",
//         xField: "type",
//         colorField: "type",
//         data: chartnewData,
//         animation: {
//           appear: {
//             animation: "scale-in-x",
//             duration: 1000,
//           },
//         },
//       });
//     }
//   }, [chartnewData]); // Only trigger this effect when chartnewData changes

//   return (
//     <ConfigProvider>
//       <DefaultLayout>
//         <Card style={{ width: "100%", height: "100%" }}>
//           <Row gutter={[16, 16]}>
//             <Col xl={6} lg={12} md={12} sm={12} xs={24}>
//               <DashboardCard_1 title="Visited" value={visited} />
//             </Col>
//             <Col xl={6} lg={12} md={12} sm={12} xs={24}>
//               <DashboardCard_2 title="Rescheduled" value={reschedule} />
//             </Col>
//             <Col xl={6} lg={12} md={12} sm={12} xs={24}>
//               <DashboardCard_3 title="Confirmed" value={confirm} />
//             </Col>
//             <Col xl={6} lg={12} md={12} sm={12} xs={24}>
//               <DashboardCard_4 title="Cancelled" value={cancel} />
//             </Col>
//           </Row>
//           <Flex justify="start" style={{ marginTop: "2vh" }}>
//             <Input
//               type={isDateInput ? "date" : "text"}
//               placeholder="From Date"
//               value={fromDate}
//               onChange={(e) => setFromDate(e.target.value)}
//               onFocus={handleFocus}
//               onBlur={handleBlur}
//               InputLabelProps={{
//                 sx: {
//                   position: "absolute",
//                   top: "50%",
//                   left: "10px",
//                   transform: "translateY(-50%)",
//                   transition: "all 0.2s ease-out",
//                   "&.MuiInputLabel-shrink": {
//                     top: "0px",
//                     transform: "translateY(-100%)",
//                   },
//                   fontSize: "14px",
//                   pointerEvents: "none",
//                 },
//               }}
//               variant="outlined"
//               style={{
//                 position: "relative",
//                 width: "160px",
//                 height: "35px",
//                 marginRight: "20px",
//               }}
//             />
//             <Input
//               type={toDateInput ? "date" : "text"}
//               placeholder="To Date"
//               value={toDate}
//               onChange={(e) => setToDate(e.target.value)}
//               onFocus={() => setToDateInput(true)}
//               onBlur={(e) => !e.target.value && setToDateInput(false)}
//               InputLabelProps={{
//                 sx: {
//                   position: "absolute",
//                   top: "50%",
//                   left: "10px",
//                   transform: "translateY(-50%)",
//                   transition: "all 0.2s ease-out",
//                   "&.MuiInputLabel-shrink": {
//                     top: "0px",
//                     transform: "translateY(-100%)",
//                   },
//                   fontSize: "14px",
//                   pointerEvents: "none",
//                 },
//               }}
//               variant="outlined"
//               style={{
//                 position: "relative",
//                 width: "150px",
//                 height: "35px",
//                 marginRight: "20px",
//               }}
//             />
//             <Button
//               onClick={handleReload}
//               size="small"
//               style={{ height: "35px", borderRadius: "8px" }}
//             >
//               <ReloadOutlined />
//             </Button>
//           </Flex>
//           <Row style={{ marginTop: "20px" }}>
//             <Col xl={13} lg={24} md={24} sm={24} xs={24}>
//               <Card
//                 title="Doctor-wise Visit"
//                 style={{ marginRight: "25px" }}
//                 headStyle={{
//                   color: "#172b4c",
//                 }}
//               >
//                 <div>
//                   <ConfigProvider
//                     theme={{
//                       components: {
//                         Table: {
//                           headerBg: "#e3e3e3b8",
//                           headerSplitColor: "#e3e3e3b8",
//                           headerSortActiveBg: "#467ecf",
//                           colorTextHeading: "black",
//                         },
//                       },
//                     }}
//                   >
//                     <Table
//                       columns={columns}
//                       dataSource={tableData}
//                       scroll={{ x: true, y: 200 }}
//                       style={{ width: "100%" }}
//                       pagination={false}
//                       rowClassName={() => "table-row-hover"} // Apply hover class
//                     />
//                   </ConfigProvider>
//                 </div>
//               </Card>
//             </Col>
//             <Col xl={11} lg={24} md={24} sm={24} xs={24}>
//               <Card
//                 title="Specialty-wise Revenue"
//                 style={{ flex: 1, width: "100%" }}
//                 headStyle={{
//                   color: "#172b4c",
//                 }}
//               >
//                 <div style={{ height: "300px", maxHeight: "500px" }}>
//                   <Bar {...config} scroll={{ x: true }} />
//                 </div>
//               </Card>
//             </Col>
//           </Row>
//         </Card>
//       </DefaultLayout>
//     </ConfigProvider>
//   );
// };
const Dashbord = () => {
  const [isDateInput, setIsDateInput] = useState(false);
  const [toDateInput, setToDateInput] = useState(false);
  const [dashboard, setDashboard] = useState({
    totaldoctor: 0,
    totalCount: [],
    totalAppt: 0,
    totalHospital: 0,
    totalLocation: 0,
  });
  const [speciality, setSpeciality] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [filteredApptCount, setFilteredApptCount] = useState(0);
  const [totalApptCount, setTotalApptCount] = useState(0);
  const [visited, setVisited] = useState(0);
  const [reschedule, setReschedule] = useState(0);
  const [confirm, setConfirm] = useState(0);
  const [cancel, setCancel] = useState(0);
  const [appt, setAppt] = useState([]);
  const [values, setValues] = useState([]);
  const userId = localStorage.getItem("userid");
  const [chartData, setChartData] = useState(null);

  const handleFocus = () => setIsDateInput(true);
  const handleBlur = (e) => {
    if (!e.target.value) setIsDateInput(false);
  };

  const handleFocusTo = () => setToDateInput(true);
  const handleBlurTo = (e) => {
    if (!e.target.value) setToDateInput(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const url = `${API_BASE_URL}${APPOINTMENT_LIST}${userId}`;
        const params = fromDate && toDate ? { fromDate, toDate } : {};
        const headers = {
          "authentication-token": `${localStorage.getItem("token")}`,
        };

        const [appointmentResponse, specialityResponse] = await Promise.all([
          axios.get(url, { headers, params }),
          axios.get(`${API_BASE_URL}${LIST_OF_MASTER_SPECIALITY}`),
        ]);

        const appointments = appointmentResponse.data.list || [];
        const specialities = specialityResponse.data.list || [];
        setValues(appointments);

        const specialityMap = specialities.reduce((map, speciality) => {
          map[speciality.id] = speciality.specialities_names;
          return map;
        }, {});

        const filteredAppointmentsByDate =
          fromDate && toDate
            ? appointments.filter((appt) => {
                const appointmentDate = new Date(appt.createdAt);
                return (
                  appointmentDate >= new Date(fromDate) &&
                  appointmentDate <= new Date(toDate)
                );
              })
            : appointments;

        const groupedAppointments = filteredAppointmentsByDate.reduce(
          (acc, appt) => {
            const key = `${appt.doctorId}-${appt.doctorSpecialityId}`;
            if (!acc[key]) {
              acc[key] = {
                ...appt,
                specialities: [specialityMap[appt.doctorSpecialityId]],
              };
            } else {
              acc[key].specialities.push(
                specialityMap[appt.doctorSpecialityId]
              );
            }
            return acc;
          },
          {}
        );

        const filteredAppointments = Object.values(groupedAppointments);
        setSpeciality(specialities);
        setAppt(filteredAppointments);

        let visitedCount = 0;
        let rescheduleCount = 0;
        let confirmCount = 0;
        let cancelCount = 0;
        filteredAppointmentsByDate.forEach((appt) => {
          switch (appt.status) {
            case "Visited":
              visitedCount++;
              break;
            case "Rescheduled":
              rescheduleCount++;
              break;
            case "Confirmed":
              confirmCount++;
              break;
            case "Cancelled":
              cancelCount++;
              break;
            default:
              break;
          }
        });

        setVisited(visitedCount);
        setReschedule(rescheduleCount);
        setConfirm(confirmCount);
        setCancel(cancelCount);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [userId, fromDate, toDate]);

  const handleReload = () => {
    setTotalApptCount(0);
    setFromDate("");
    setToDate("");
  };

  const columns = [
    {
      title: "Doctor",
      dataIndex: "doctorName",
      key: "doctorName",
      // width: "3px",
      // maxWidth: "3rem",
      // minWidth: "2.5rem",
    },
    {
      title: "Specialty",
      dataIndex: "specialitiesName",
      key: "specialitiesName",
      // width: "3px",
      // maxWidth: "5rem",
      // minWidth: "4.5rem",
    },
    {
      title: "Appointment",
      dataIndex: "Appointment",
      key: "Appointment",
      width: "120px",
      maxWidth: "120px",
      minWidth: "110px",
      // width: "7.5rem",
      // maxWidth: "7rem",
      // minWidth: "6.5rem",
    },
    {
      title: "Visited",
      dataIndex: "Visited",
      key: "Visited",
      width: "80px",
      // width: "5rem",
      // maxWidth: "5rem",
      // minWidth: "4.5rem",
    },
    {
      title: "Visit Conversion",
      dataIndex: "Total",
      key: "Total",
      width: "100px",

      render: (total, record) => {
        const totalAppointments = parseFloat(record.Appointment) || 0;
        const visitedAppointments = parseFloat(record.Visited) || 0;

        const percentage =
          totalAppointments > 0
            ? (visitedAppointments / totalAppointments) * 100
            : 0;

        return (
          <Progress
            percent={percentage.toFixed(0)}
            status={percentage === 100 ? "success" : "normal"}
          />
        );
      },
    },
  ];

  const tableData = appt.map((item, index) => ({
    key: index.toString(),
    doctorName: item.doctorName,
    specialitiesName: item.specialitiesName,
    Appointment: item.Appointment,
    Visited: item.Visited,
    Total: `${parseFloat(item.Total || 0).toFixed(0)}%`,
  }));

  const specialtyPriceMap = values.reduce((map, item) => {
    if (item.specialitiesName) {
      map[item.specialitiesName] =
        (map[item.specialitiesName] || 0) + parseFloat(item.charges || 0);
    }
    return map;
  }, {});

  const data = Object.keys(specialtyPriceMap)
    .map((specialty) => ({
      type: specialty,
      value: specialtyPriceMap[specialty],
    }))
    .sort((a, b) => b.value - a.value);

  const chartDataObject = {
    labels: data.map((item) => item.type),
    datasets: [
      {
        label: "Specialty-wise Revenue",
        data: data.map((item) => item.value),
        // backgroundColor: "rgba(75, 192, 192, 0.2)",
        // backgroundColor: "rgba(100, 153, 241, 0.4)",
        backgroundColor: data.map((_, index) =>
          index % 2 === 0
            ? "rgba(100, 153, 241, 0.4)"
            : "rgba(75, 192, 192, 0.4)"
        ),
        borderColor: "rgba(100, 153, 241, 0.4)",
        borderWidth: 1,
        borderRadius: 10, // Adjust this value to get the curve you want
        barThickness: 20,
      },
    ],
  };
  // const options = {
  //   indexAxis: "y", // This will swap the X and Y axes
  // };
  const options = {
    indexAxis: "y", // This will swap the X and Y axes
    scales: {
      y: {
        max: 4, // Set max limit for Y-axis
      },
    },
  };
  return (
    <ConfigProvider>
      <DefaultLayout>
        <Card style={{ width: "100%", height: "100%" }}>
          <Row gutter={[16, 16]}>
            <Col xl={6} lg={12} md={12} sm={12} xs={24}>
              <DashboardCard_1 title="Visited" value={visited} />
            </Col>
            <Col xl={6} lg={12} md={12} sm={12} xs={24}>
              <DashboardCard_2 title="Rescheduled" value={reschedule} />
            </Col>
            <Col xl={6} lg={12} md={12} sm={12} xs={24}>
              <DashboardCard_3 title="Confirmed" value={confirm} />
            </Col>
            <Col xl={6} lg={12} md={12} sm={12} xs={24}>
              <DashboardCard_4 title="Cancelled" value={cancel} />
            </Col>
          </Row>
          <Flex justify="start" style={{ marginTop: "2vh" }}>
            <Input
              type={isDateInput ? "date" : "text"}
              placeholder="From Date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              onFocus={handleFocus}
              onBlur={handleBlur}
              InputLabelProps={{
                sx: {
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translateY(-50%)",
                  transition: "all 0.2s ease-out",
                  "&.MuiInputLabel-shrink": {
                    top: "0px",
                    transform: "translateY(-100%)",
                  },
                  fontSize: "14px",
                  pointerEvents: "none",
                },
              }}
              variant="outlined"
              style={{
                position: "relative",
                width: "160px",
                height: "35px",
                marginRight: "20px",
              }}
            />
            <Input
              type={toDateInput ? "date" : "text"}
              placeholder="To Date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              onFocus={() => setToDateInput(true)}
              onBlur={(e) => !e.target.value && setToDateInput(false)}
              InputLabelProps={{
                sx: {
                  position: "absolute",
                  top: "50%",
                  left: "10px",
                  transform: "translateY(-50%)",
                  transition: "all 0.2s ease-out",
                  "&.MuiInputLabel-shrink": {
                    top: "0px",
                    transform: "translateY(-100%)",
                  },
                  fontSize: "14px",
                  pointerEvents: "none",
                },
              }}
              variant="outlined"
              style={{
                position: "relative",
                width: "150px",
                height: "35px",
                marginRight: "20px",
              }}
            />
            <Button
              onClick={handleReload}
              size="small"
              style={{ height: "35px", borderRadius: "8px" }}
            >
              <ReloadOutlined />
            </Button>
          </Flex>
          <Row style={{ marginTop: "20px" }}>
            <Col xl={13} lg={24} md={24} sm={24} xs={24}>
              <Card
                title="Doctor-wise Visit"
                style={{ marginRight: "25px" }}
                headStyle={{
                  color: "#172b4c",
                }}
              >
                <div>
                  <ConfigProvider
                    theme={{
                      components: {
                        Table: {
                          headerBg: "#e3e3e3b8",
                          headerSplitColor: "#e3e3e3b8",
                          headerSortActiveBg: "#467ecf",
                          colorTextHeading: "black",
                        },
                      },
                    }}
                  >
                    <Table
                      columns={columns}
                      dataSource={tableData}
                      scroll={{ x: true, y: 200 }}
                      style={{ width: "100%" }}
                      pagination={false}
                    />
                  </ConfigProvider>
                </div>
              </Card>
            </Col>
            <Col xl={11} lg={24} md={24} sm={24} xs={24}>
              <Card title="Specialty-wise Revenue" style={{ width: "100%" }}>
                <div
                  style={{
                    // height: "350/x",
                    // minHeight: "200px",
                    // // width: "500px",
                    // // minWidth: "450px",
                    minHeight: "300px",
                    height: "100%",
                    maxHeight: "600px",
                  }}
                >
                  <Bar data={chartDataObject} options={options} />
                </div>
              </Card>
            </Col>
          </Row>
        </Card>
      </DefaultLayout>
    </ConfigProvider>
  );
};

// function DashboardCard_1({ title, value }) {
//   return (
//     <Card
//       style={{
//         width: "100%",
//         // minWidth: "100px",
//         // maxWidth: "300px",
//         height: "100px",
//         borderRadius: "12px",
//         color: "#2aeac266",
//         borderColor: "#05825f",
//         position: "relative",
//         transition: "transform 0.3s ease, box-shadow 0.3s ease", // Add transition for smooth hover effect
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.transform = "scale(1.02)";
//         e.currentTarget.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)";
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.transform = "scale(1)";
//         e.currentTarget.style.boxShadow = "none";
//       }}
//     >
//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         <img
//           src={Visitedimg}
//           alt="Visitedimg"
//           style={{
//             width: "100px",
//             height: "100px",
//             marginBottom: "20px",
//             // margin: "0",
//             // padding: "0",
//           }}
//         />
//         <div>
//           <div
//             style={{
//               color: "#05825f",
//               fontSize: "35px",
//               fontWeight: "500px",
//             }}
//           >
//             {value}
//           </div>
//           <div
//             style={{ color: "#475f7b", fontSize: "18px", textAlign: "right" }}
//           >
//             {title}
//           </div>
//         </div>
//       </div>
//     </Card>
//   );
// }
function DashboardCard_1({ title, value }) {
  return (
    <Card
      style={{
        width: "100%",
        height: "100px",
        borderRadius: "12px",
        borderColor: "#05825f",
        position: "relative",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        display: "flex",
        alignItems: "center",
        padding: "10px 20px", // More padding for spacing
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.02)";
        e.currentTarget.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <div
        style={{
          display: "flex",

          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <img
          src={Visitedimg}
          alt="Visitedimg"
          style={{
            width: "80px",
            height: "80px",
            flexShrink: 0,
            marginRight: "60px",
          }}
        />
        <div style={{ flexGrow: 1 }}>
          <div
            style={{
              color: "#05825f",
              fontSize: "35px",
              fontWeight: "600",
            }}
          >
            {value}
          </div>
          <div
            style={{
              color: "#475f7b",
              fontSize: "18px",
            }}
          >
            {title}
          </div>
        </div>
      </div>
    </Card>
  );
}

function DashboardCard_2({ title, value }) {
  return (
    <Card
      style={{
        width: "100%",
        height: "100px",
        // maxWidth: "300px",
        // minWidth: "100px",
        borderRadius: "12px",
        // height: "120px",
        borderColor: "#00baff",
        color: "#00baff",
        position: "relative",
        transition: "transform 0.3s ease, box-shadow 0.3s ease", // Add transition for smooth hover effect
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.02)";
        e.currentTarget.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "none";
      }}
      // onMouseEnter={(e) => {
      //   e.currentTarget.style.transform = "scale(1.02)"; // Scale the card slightly
      //   e.currentTarget.style.boxShadow = "#a2a4a8d4"; // Add shadow on hover
      // }}
      // onMouseLeave={(e) => {
      //   e.currentTarget.style.transform = "scale(1)"; // Reset scaling
      //   e.currentTarget.style.boxShadow = "#a2a4a8d4"; // Remove shadow
      // }}
    >
      {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
        <img
          src={Reschedule}
          alt="Reschedule"
          style={{
            width: "100px",
            height: "100px",
            margin: "0",
            padding: "0",
          }}
        />

        <div>
          <div
            style={{
              color: "#00baff",
              fontSize: "35px",
              fontWeight: "500px",
            }}
          >
            {value}
          </div>
          <div
            style={{ color: "#475f7b", fontSize: "18px", textAlign: "right" }}
          >
            {title}
          </div>
        </div>
      </div> */}
      <div
        style={{
          display: "flex",

          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <img
          src={Reschedule}
          alt="Reschedule"
          style={{
            width: "80px",
            height: "80px",
            // margin: "0",
            flexShrink: 0,
            marginRight: "60px",
          }}
        />
        <div style={{ flexGrow: 1 }}>
          <div
            style={{
              color: "#00baff",
              fontSize: "30px",
              fontWeight: "600",
            }}
          >
            {value}
          </div>
          <div
            style={{
              color: "#475f7b",
              fontSize: "18px",
            }}
          >
            {title}
          </div>
        </div>
      </div>
    </Card>
  );
}

function DashboardCard_3({ title, value }) {
  return (
    <Card
      style={{
        width: "100%",
        height: "100px",
        // minWidth: "100px",
        // maxWidth: "300px",
        // height: "120px",
        borderRadius: "12px",
        borderColor: " #455ae9",
        color: "#3366ff",
        position: "relative",
        overflow: "hidden",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
      }}
      // style={{
      //   width: "100%",
      //   minWidth: "100px",
      //   maxWidth: "300px",
      //   height: "120px",
      //   borderRadius: "12px",
      //   border: "1px solid #455ae9",
      //   color: "#3366ff",
      //   position: "relative",
      //   overflow: "hidden", // Ensures content stays inside the card
      //   display: "flex",
      //   alignItems: "center", // Aligns content vertically
      //   transition: "transform 0.3s ease, box-shadow 0.3s ease",
      // }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.02)";
        e.currentTarget.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {/* <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          // width: "100%",
          // padding: "10px",
        }}
      >
        <img
          src={confromationimg}
          alt="Confirmation"
          style={{
            width: "100px",
            height: "100px",
            // objectFit: "contain", // Ensures the image fits properly
            // borderRadius: "8px", // Optional: Adds rounded corners to the image
          }}
        />
        <div style={{ marginLeft: "10px" }}>
          <div
            style={{
              color: "#05825f",
              fontSize: "28px",
              fontWeight: "500", // Corrected: `fontWeight` expects a number or valid CSS string
            }}
          >
            {value}
          </div>
          <div
            style={{
              color: "#475f7b",
              fontSize: "18px",
              textAlign: "start",
              // marginTop: "5px",
            }}
          >
            {title}
          </div>
        </div>
      </div> */}
      <div
        style={{
          display: "flex",

          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <img
          src={confromationimg}
          alt="Confirmation"
          style={{
            width: "80px",
            height: "80px",
            flexShrink: 0,
            marginRight: "60px",
          }}
        />
        <div style={{ flexGrow: 1 }}>
          <div
            style={{
              color: "#4a69ff",
              fontSize: "30px",
              fontWeight: "600",
            }}
          >
            {value}
          </div>
          <div
            style={{
              color: "#475f7b",
              fontSize: "18px",
            }}
          >
            {title}
          </div>
        </div>
      </div>
    </Card>
  );
}

function DashboardCard_4({ title, value }) {
  return (
    <Card
      style={{
        width: "100%",
        height: "100px",
        // minWidth: "100px",
        // maxWidth: "300px",/
        // height: "120px",
        borderRadius: "12px",
        borderColor: "red",
        color: "#ff562f",
        position: "relative",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.02)";
        e.currentTarget.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "none";
      }}
      // onMouseEnter={(e) => {
      //   e.currentTarget.style.transform = "scale(1.02)";
      //   e.currentTarget.style.boxShadow = "#a2a4a8d4";
      // }}
      // onMouseLeave={(e) => {
      //   e.currentTarget.style.transform = "scale(1)";
      //   e.currentTarget.style.boxShadow = "#a2a4a8d4";
      // }}
    >
      {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
        <img
          src={Cancel}
          alt="Cancel"
          style={{
            width: "100px", // Adjust the width as needed
            height: "100px",
            margin: "0px",
            padding: "0px",
          }}
        />
        <div>
          <div
            style={{
              color: "#ff562f",
              fontSize: "35px",
              fontWeight: "500px",
            }}
          >
            {value}
          </div>
          <div
            style={{ color: "#475f7b", fontSize: "16px", textAlign: "start" }}
          >
            {title}
          </div>
        </div>
      </div> */}
      <div
        style={{
          display: "flex",

          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <img
          src={Cancel}
          alt="Cancel"
          style={{
            width: "80px",
            height: "80px",
            flexShrink: 0,
            marginRight: "60px",
          }}
        />
        <div style={{ flexGrow: 1 }}>
          <div
            style={{
              color: "#ff562f",
              fontSize: "30px",
              fontWeight: "600",
            }}
          >
            {value}
          </div>
          <div
            style={{
              color: "#475f7b",
              fontSize: "18px",
            }}
          >
            {title}
          </div>
        </div>
      </div>
    </Card>
  );
}

export default Dashbord;
